module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0742d_banner_800x600.869f9e3c.png";